"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.orderRepositoryMethods = void 0;
const repository_types_1 = require("./repository.types");
exports.orderRepositoryMethods = (0, repository_types_1.generateRepositoryMethods)({
    createOrder: {
        callMethod: 'POST',
        endpoint: '/order/create',
    },
    getNextPlannedReorderDate: {
        callMethod: 'GET',
        endpoint: '/order/planned/next/date',
    },
    getNextOpenOrder: {
        callMethod: 'GET',
        endpoint: '/order/open/next',
    },
    getPaginatedOrders: {
        callMethod: 'GET',
        endpoint: '/order/paginated',
    },
    cancelPlannedOrder: {
        callMethod: 'POST',
        endpoint: '/order/planned/cancel',
    },
    getPlannedOrders: {
        callMethod: 'GET',
        endpoint: '/order/planned',
    },
    getAutomaticOrderableProducts: {
        callMethod: 'GET',
        endpoint: '/automatic-orderable-products/list',
    },
    createAutomaticReorderConfig: {
        callMethod: 'POST',
        endpoint: '/automatic-orderable-products/create-config',
    },
    triggerOrderReminder: {
        callMethod: 'POST',
        endpoint: '/order/trigger-reminder',
    },
    getAllOrderableProducts: {
        callMethod: 'GET',
        endpoint: '/orderable-products/all',
    },
});
//# sourceMappingURL=order.methods.js.map